import { render, staticRenderFns } from "./MaterialFee.vue?vue&type=template&id=5c349e43&scoped=true&"
import script from "./MaterialFee.vue?vue&type=script&lang=js&"
export * from "./MaterialFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c349e43",
  null
  
)

export default component.exports